import { Alert } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

export default function ErrorBlock({ title, message }) {
  return (
    <Alert
      message={title}
      description={message}
      type="error"
      showIcon
      icon={<ExclamationCircleOutlined />}
      className="rounded-xl border-0 shadow-sm mt-4"
      style={{
        background: "linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)",
        border: "1px solid #fecaca",
      }}
    />
  );
}
